// ----------------------------------------------------------------------
// <copyright file="Izenda.DashboardList.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!(function() {
  var React = require('react');
  var connect = require('share/enhancers/Izenda.Connect');
  var actions = require('./Izenda.DashboardListAction');

  var classnames = require('classnames');
  var constants = require('logic/data/Izenda.DashboardConstants');
  var ScrollBox = require('share/components/controls/Izenda.ScrollBox');
  var DashboardItem = require('./Izenda.DashboardItem');
  var GridLayout = require('share/components/controls/Izenda.GridLayout');
  var DashboardListHeader = require('share/components/controls/Izenda.BoardListHeader')(constants);
  var LazyLoading = require('share/components/controls/LazyLoading/Izenda.LazyLoading');
  const { omit, forEach, isEqual, isNil, has, isEmpty, size, getOr } = require('lodash/fp');

  var DashboardList = React.createClass({
    propTypes: {
      store: React.PropTypes.object
    },

    componentWillMount() {
      this.props.loader.startLoading();
    },

    componentDidMount: function() {
      this.props.store.dashboardDesignerMode.reset();
      this.props.loader.endLoading();
    },

    componentWillReceiveProps: function(nextProps) {
      const nextLocation = omit(['key', 'action', 'state'], nextProps.location);
      const currentLocation = omit(['key', 'action', 'state'], this.props.location);
      const restNextProps = omit(['isGlobalExpand', 'isLocalExpand', 'location'], nextProps);
      const restProps = omit(['isGlobalExpand', 'isLocalExpand', 'location'], this.props);
      if (!isEqual(nextLocation, currentLocation) || !isEqual(restNextProps, restProps)) {
        this.isReload = true;
        this.loadDashboardList(nextProps);
      }
    },

    loadDashboardList: function(props) {
      var catId = props.params.catId,
        isGlobal = props.params.isGlobal,
        loader = props.loader;

      loader.startLoading();
      props.store.lazyLoadingDashboards(catId, true, isGlobal).finally(loader.endLoading.bind(loader));
    },

    render: function() {
      var props = this.props;
      var store = props.store;
      var subscriptionStore = props.subscriptionStore;
      this.globalLocalCount = 0;
      var dashboardList = getDashboardList.call(this, store.items.categories);
      var getData = getDataFunc();
      return (
        <div className="izenda-Wrapper izenda-DashboardList-container">
          <DashboardListHeader ref="dashboardListHeader" store={store} isGlobal={props.isGlobal} />
          <section className="izenda-DashboardList izenda-Wrapper-content u_paddingLeftRight">
            <ScrollBox>
              <LazyLoading
                data={dashboardList}
                isLastPage={store.items.isLastPage}
                getData={getData}
                renderItem={renderDashboard.bind(this)}
                registerLazyLoadingStore={store.registerContentLazyLoadingStore.bind(store)}
                loader={isNil(this.isReload) && props.loader}
              />
            </ScrollBox>
          </section>
        </div>
      );

      function getDashboardList(globalLocalCategories) {
        var dashboardList = [];
        var dashboards, numDashboards;

        forEach(
          function(globalLocalCategory) {
            this.globalLocalCount++;

            if (globalLocalCategory.isVirtualNode) {
              dashboardList.push(globalLocalCategory);
              return;
            }

            dashboardList.push({
              key: globalLocalCategory.isGlobal
                ? 'GlobalCategory_' + props.isGlobalExpand
                : 'LocalCategory_' + props.isLocalExpand,
              isGlobal: globalLocalCategory.isGlobal,
              globalLocalCategory: globalLocalCategory
            });

            ((globalLocalCategory.isGlobal && props.isGlobalExpand) ||
              (!globalLocalCategory.isGlobal && props.isLocalExpand)) &&
              forEach(function(category) {
                if (category.isVirtualNode) {
                  dashboardList.push(category);
                  return;
                }

                if (category.canDelete) return;

                forEach(function(subCategory) {
                  if (subCategory.isVirtualNode) {
                    dashboardList.push(subCategory);
                    return;
                  }

                  if (subCategory.canDelete) return;

                  dashboards = getOr([], 'dashboards', subCategory);
                  numDashboards = size(dashboards);

                  dashboards.forEach(function(dashboard, index) {
                    if (dashboard.isVirtualNode) {
                      dashboardList.push(dashboard);
                      return;
                    }

                    dashboardList.push({
                      key: dashboard.id,
                      isGlobal: category.isGlobal,
                      isFirstItem: index === 0,
                      isLastItem: index === numDashboards - 1,
                      category: category,
                      subCategory: subCategory,
                      dashboard: dashboard
                    });
                  }, subCategory.dashboards);
                }, category.subCategories);
              }, globalLocalCategory.subCategories);
          }.bind(this),
          globalLocalCategories
        );

        return dashboardList;
      }

      function renderGlobalLocalCategory(groupInfo) {
        var isGlobal = groupInfo.isGlobal;
        var expandCollapse = classnames({
          'icon-minus-circled': (isGlobal && props.isGlobalExpand) || (!isGlobal && props.isLocalExpand),
          'icon-plus-circled': (isGlobal && !props.isGlobalExpand) || (!isGlobal && !props.isLocalExpand)
        });

        var className = classnames({
          u_paddingTop: !isGlobal && this.globalLocalCount === 2
        });

        return (
          <GridLayout className={className}>
            <GridLayout.Row className="u_paddingTopBottom u_noMarginAll u-bgWhite">
              <GridLayout.Col cols={11}>
                <div className="u_textBold u_textUppercase">{groupInfo.globalLocalCategory.name}</div>
              </GridLayout.Col>
              <GridLayout.Col cols={1}>
                <div className="u_floatRight">
                  <a onClick={props.toggle.bind(props, isGlobal)}>
                    <span className={expandCollapse} />
                  </a>
                </div>
              </GridLayout.Col>
            </GridLayout.Row>
          </GridLayout>
        );
      }

      function renderDashboard(groupInfo) {
        if (has('globalLocalCategory', groupInfo)) {
          return renderGlobalLocalCategory.call(this, groupInfo);
        }
        return (
          <DashboardItem
            {...groupInfo}
            selectedDashboardId={props.params.dashboardId}
            store={store}
            subscriptionStore={subscriptionStore}
          />
        );
      }

      function getDataFunc() {
        return !isEmpty(store.items.searchText)
          ? store.lazyLoadingSearch.bind(store, props.params.isGlobal)
          : store.lazyLoadingDashboards.bind(store, props.params.catId, false, props.params.isGlobal);
      }
    }
  });

  module.exports = connect(actions)(DashboardList);
})();



// WEBPACK FOOTER //
// ./ui/modules/Dashboard/DashboardList/Izenda.DashboardList.jsx